import React, { useContext, useRef, useState } from 'react';
import { Select } from 'antd';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import LoadingAnimation from '../../components/LoadingAnimation';
import ViewBookDetails from './ViewBookDetails';
import ModalWrapper from '../../components/ModalWrapper';
import SearchableImput from '../../NecttosComp/Input/SearchableImput';
import Button from '../../NecttosComp/Button/Button';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import { Table, Thead, Tbody, Tr, Th, Td } from '../../NecttosComp/Table/Table';
import Input2 from '../../NecttosComp/Input/Input2';
import Instruction from '../../Documentation/Instruction';

const getFieldDropDowns = (data) => async () => {
	let { setLoading } = data;
	setLoading(true);
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/college/library/getOpac', {
			params: { ...data },
		});
		if (resp.data.statusCode === 400) {
			setLoading(false);
			throw new Error(resp.data.message || 'API Error');
		} else {
			setLoading(false);
			return resp?.data?.opacData[0];
		}
	} catch (error) {
		setLoading(false);
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};

export const Opac = ({ onClose }) => {
	const { collegeId } = useContext(FirebaseContext);
	const [state, setState] = React.useState({
		filterValue: '',
		page: 0,
		nameOfBook: '',
		author: '',
		subject: '',
		callNo: '',
		contents: '',
		accessionNumber: '',
	});
	const componentRef = useRef();
	const [loading, setLoading] = useState(false);

	const {
		data = [],
		refetch,
		isLoading,
	} = useQuery(
		['opacData', state.page],
		getFieldDropDowns({
			collegeId,
			nameOfBook: state.nameOfBook,
			nameOfAuthor: state.nameOfAuthor,
			subject: state.subject,
			callNo: state.callNo,
			accessionNumber: state.accessionNumber,
			contents: state.contents,
			skip: state.page * 50,
			setLoading,
		}),
		{ keepPreviousData: true },
	);

	let [items, setItems] = React.useState({
		addBook: false,
	});

	console.log({ state });

	const { Option } = Select;
	let filterTypeDrops = ['All', 'Title', 'Author', 'Subjects', 'Call No', 'Accession No', 'Contents'];

	return (
		<Main title='OPAC' width='100%' height='100%' className='flex items-center justify-center bg-black bg-opacity-70 absolute inset-0 z-[790] w-full h-full'>
			<Header className='w-full px-4 pt-4'>
				<div className='flex flex-col gap-4 w-full'>
					<div className='flex flex-wrap gap-4 w-full'>
						<div className='w-full sm:w-[250px]'>
							<SearchableImput
								keyData='nameOfBook'
								titleData='Title'
								collection='books'
								stateData={state}
								setStateData={(newState) => {
									setState(newState);
									refetch();
								}}
							/>
						</div>
						<div className='w-full sm:w-[200px]'>
							<SearchableImput
								keyData='nameOfAuthor'
								titleData='Author'
								collection='books'
								stateData={state}
								setStateData={(newState) => {
									setState(newState);
									refetch();
								}}
							/>
						</div>
						<div className='w-full sm:w-[200px]'>
							<SearchableImput
								keyData='subject'
								titleData='Subjects'
								collection='bookStocks'
								stateData={state}
								setStateData={(newState) => {
									setState(newState);
									refetch();
								}}
							/>
						</div>
						<div className='w-[200px]'>
							<SearchableImput
								keyData='callNo'
								titleData='Call No'
								collection='bookStocks'
								stateData={state}
								setStateData={(newState) => {
									setState(newState);
									refetch();
								}}
							/>
						</div>
						<div className='w-[200px]'>
							<SearchableImput
								keyData='accessionNumber'
								titleData='Acc No'
								collection='bookStocks'
								stateData={state}
								setStateData={(newState) => {
									setState(newState);
									refetch();
								}}
							/>
						</div>
						<div className='w-full sm:w-[250px]'>
							<SearchableImput
								keyData='contents'
								titleData='Contents'
								collection='books'
								stateData={state}
								setStateData={(newState) => {
									setState(newState);
									refetch();
								}}
							/>
						</div>
					</div>

					<div className='flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 w-full'>
						<div className='flex flex-wrap gap-2'>
							<Button type='search' className='h-[40px] w-[100px] rounded-[30px]' onClick={() => refetch()}>
								Search
							</Button>
							<Button type='print' tableRef={componentRef.current}>
								Print
							</Button>
							<Instruction keyId='opac' />
							<Button type='close' className='h-[40px] w-[100px] rounded-[20px]' onClick={onClose}>
								Close
							</Button>
						</div>

						<div className='w-full sm:w-auto dark:bg-neutral-600 shadow-md rounded-2xl px-4  flex flex-col sm:flex-row items-center gap-3'>
							<div className='flex items-center gap-2'>
								<Button type='update' disabled={parseInt(state.page) < 1} onClick={() => setState({ ...state, page: parseInt(state.page) - 1 })}>
									Prev
								</Button>
								<Input2
									type='number'
									returnKey='page'
									fieldName='Page'
									state={state}
									setState={(val) => {
										const pageNum = parseInt(val?.page) || 1;
										setState({ ...state, page: pageNum - 1 });
									}}
									className='!h-10 !rounded-full !text-sm font-semibold !w-[90px] !px-2 shadow-inner m-4 !outline-none !ring-0 !focus:ring-0 !focus:outline-none'
									labelClass='absolute -top-3 left-2 text-[9px] font-semibold text-slate-600 dark:text-slate-300'
									wrapperClass='relative'
								/>
								<Button type='update' isabled={parseInt(state.page) * 50 > parseInt(data?.total?.[0]?.total) - 50} onClick={() => setState({ ...state, page: parseInt(state.page) + 1 })}>
									Next
								</Button>
							</div>
							<div className='flex items-center text-sm font-semibold text-slate-700 dark:text-slate-200 whitespace-nowrap'>
								{loading ? (
									<LoadingAnimation customHeight={30} customWidth={30} />
								) : (
									<span>
										Showing: {parseInt(state.page) * 50 + 1} - {Math.min(parseInt(state.page) * 50 + 50, parseInt(data?.total?.[0]?.total))} of {data?.total?.[0]?.total}
									</span>
								)}
							</div>
						</div>
					</div>
				</div>
			</Header>

			<Body className='w-full h-full bg-[#f2f2f2] rounded-[25px]'>
				{loading ? (
					<LoadingAnimation dark />
				) : (
					<div className='w-full flex flex-col px-4 pt-[38px] pb-6'>
						<div className='w-full flex-1'>
							<div ref={componentRef} className='printable overflow-x-auto print:overflow-visible'>
								<div className='min-w-[1200px] print:min-w-full w-full flex flex-col rounded-[25px] p-[1%]'>
									<Table
  id='print-table'
  width='100%'
  innerWidth={['4%', '6%', '28%', '14%', '6%', '14%', '10%', '8%', '6%', '4%']}
>

										<Thead>
											<Tr>
												<Th position={0} item='Sn' />
												<Th position={1} item='Cover' />
												<Th position={2} item='Title' />
												<Th position={3} item='Author' />
												<Th position={4} item='Ed' />
												<Th position={5} item='Publisher' />
												<Th position={6} item='Call No' />
												<Th position={7} item='Acc No' />
												<Th position={8} item='Status' />
												<Th position={9} item='Options' />
											</Tr>
										</Thead>

										<Tbody height='60vh'>
											{data?.data?.map((item, i) => (
												<Tr
													key={i}
													onClick={() => setItems({ ...items, addBook: true, stockId: item._id })}
													style={{
														backgroundColor: item.callNo === '' ? '#ff8f87' : item.status === 'available' ? 'white' : '#ff8f87',
														cursor: 'pointer',
													}}>
													<Td position={0} item={parseInt(state.page) * 50 + 1 + i} textAlign='center' />
													<Td position={1} item={<img className='w-full h-[50px] object-cover rounded-[10px]' src={item?.image} alt='Book cover' />} />
													<Td position={2} item={item.nameOfBook} textAlign='left' />
													<Td position={3} item={item.nameOfAuthor} textAlign='left' />
													<Td position={4} item={item.edition} textAlign='center' />
													<Td position={5} item={item.nameOfPublisher} textAlign='left' />
													<Td position={6} item={item.callNo} textAlign='left' />
													<Td position={7} item={item.accessionNumber} textAlign='center' />
													<Td position={8} item={item.status === 'unAvailable' ? 'Unavailable' : item.status === 'available' ? 'Available' : item.status} textAlign='center' />
													<Td
														position={9}
														item={
															<div className='print:hidden'>
																<Button
																	type='edit'
																	className='h-[30px] w-[70px] shadow-md py-0.5 border-none rounded-[30px]'
																	onClick={(e) => {
																		e.stopPropagation();
																		setItems({ ...items, addBook: true, stockId: item._id });
																	}}>
																	View
																</Button>
															</div>
														}
														textAlign='center'
													/>
												</Tr>
											))}
										</Tbody>
									</Table>
								</div>
							</div>
						</div>
					</div>
				)}
			</Body>

			{items.addBook && (
				<ModalWrapper>
					<ViewBookDetails onCloseModal={() => setItems({ ...items, addBook: false })} stockId={items.stockId} />
				</ModalWrapper>
			)}
		</Main>
	);
};

export default Opac;
